import { DashboardEmbedType } from "@common-shared/config/metabase.config.ts"
import type {
    IPractice,
    ITokenResponseData,
} from "@common-shared/types/responseData/commonResponseData.types.ts"

import { API_ROUTES } from "../config/routes.config"
import { HttpHelper } from "../helpers/http.helper"
import { UtilHelper } from "../helpers/util.helper"

export class DashboardService {
    /**
     * Get embed token for dashboard/question embed
     */
    static async getEmbedToken(
        practice: IPractice,
        embedType: DashboardEmbedType,
        embedId: number,
    ): Promise<ITokenResponseData | null> {
        const result = await HttpHelper.sendRequest(
            API_ROUTES.DASHBOARD_GET_EMBED_TOKEN.replace(
                ":practiceId",
                practice.id.toString(),
            ),
            {
                embedType,
                embedId,
            },
            "GET",
        )

        return !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : null
    }
}
